"use client";

import { BookOpen, Home, Library } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useI18n } from "@/locales/client";

export function NavMain() {
  const t = useI18n();
  const pathname = usePathname();
  const items = [
    {
      title: t("home"),
      url: "/",
      icon: Home,
    },
    {
      title: t("myLibrary"),
      url: "/my-studysets",
      icon: Library,
    },
    {
      title: t("publicLibrary"),
      url: "/studysets",
      icon: BookOpen,
    },
    // {
    //   title: "Notifications",
    //   url: "/notifications",
    //   icon: Bell,
    // },
  ];
  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                isActive={pathname === item.url}
                tooltip={item.title}
                asChild
              >
                <Link href={item.url}>
                  {item.icon && <item.icon className="size-4" />}
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
